import axios from 'axios';

import config from '../config'

import {
    SubcontractProjectForEdit,
    SubcontractRequest, SubcontractRequestResult, Subcontracts, SubcontractSaveResult, TradeSaveResult,
} from '@/types/supplier-search'

const instance = axios.create({
    baseURL: config.baseTenderWebApiUrl,
    timeout: 10000000,
    withCredentials: true,
    headers: { Pragma: 'no-cache' }
});

export class BaseTenderWebApi {
    public static getOffersStatistic = (data: SubcontractRequest) => instance.post<SubcontractRequestResult>('/SupplierFinder/get-offers-statistics', data);
    public static createSubcontracts = (data: Subcontracts) => instance.post<SubcontractSaveResult>('/SubcontractingRequest/Create', data);
    public static editSubcontracts = (data: Subcontracts) => instance.post<SubcontractSaveResult>('/SubcontractingRequest/Edit', data);
    public static saveTrade = (data: SubcontractProjectForEdit) => instance.post<TradeSaveResult>('/Trade/SaveTrade', data);
    public static getTimeZones = () => instance.get<TradeSaveResult>('/Organization/GetOrganizationTimeZones');
}